import script from "./ViewRoster.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewRoster.vue?vue&type=script&setup=true&lang=js"

import "./ViewRoster.vue?vue&type=style&index=0&id=00172efe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00172efe"]])

export default __exports__